module.exports = {
      id: "training-start-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/symbols.b783b922d187f028e7dcd3736258c276.svg#training-start",
      toString: function () {
        return this.url;
      }
    }